import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import "./brand.css";
import "./measureFlow.css";

history.scrollRestoration = "manual";

if ("serviceWorker" in navigator && import.meta.env.PROD) window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js"));
createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
